export default __webpack_public_path__ + "static/media/upload_placeholder.43317046.svg";